import { render, staticRenderFns } from "./PieCharts2.vue?vue&type=template&id=3452d107&scoped=true&"
import script from "./PieCharts2.vue?vue&type=script&lang=js&"
export * from "./PieCharts2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3452d107",
  null
  
)

export default component.exports